"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_2 = require("react");
var next_intl_1 = require("next-intl");
var ActionButton = function () {
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var depositCount = (0, swr_hooks_1.useDepositCount)().data;
    var onButtonClick = (0, react_2.useCallback)(function () {
        if (isAuth)
            openDeposit();
        else
            openSignUp();
    }, [openDeposit, openSignUp, isAuth]);
    return (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: onButtonClick, width: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '100vw'
            : '280px', maxWidth: "90vw", height: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '46px'
            : '56px' }, isAuth
        ? depositCount && depositCount > 4
            ? t('deposit')
            : t('getBonus')
        : t('joinNow')));
};
exports.default = ActionButton;
